module.exports = __webpack_public_path__ + "static/media/header_slide_08.c9ae1e62.jpg";